import { Box } from '@mui/material'
import { m } from 'framer-motion'
import { useTheme, alpha } from '@mui/material/styles'
import Logo from './Logo'

const Loader = ({ fullScreen = false }) => {
  const theme = useTheme()
  // Стили для контейнера, который центрирует лоадер
  const containerStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: fullScreen ? '100vh' : '100%',
    position: fullScreen ? 'fixed' : 'relative',
    top: 0,
    left: 0,
    bgcolor: fullScreen ? 'background.default' : 'transparent',
    zIndex: 9999,
    // Установим минимальную высоту для неполноэкранного режима, чтобы лоадер не "схлопывался"
    minHeight: fullScreen ? 'auto' : '200px',
  }

  // Параметры для анимации "ряби"
  const rippleTransition = {
    duration: 3, // Замедлим анимацию для большей плавности
    // Возвращаем кривую, которая имитирует быстрое расхождение и плавное затухание
    ease: [0.22, 1, 0.36, 1],
    repeat: Infinity,
  }

  return (
    <Box sx={containerStyles}>
      {/* Центральный логотип с легкой пульсацией */}
      <Box
        component={m.div}
        animate={{ scale: [1, 1.15, 1] }} // Сделаем пульсацию более выраженной
        transition={{
          duration: 2, // Немного замедлим пульсацию для "дышащего" эффекта
          ease: 'easeInOut',
          repeat: Infinity,
        }}
        sx={{ zIndex: 1 }}
      >
        <Logo
          disabledLink
          sx={{
            width: 64,
            height: 64,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1rem',
          }}
        />
      </Box>

      {/* Расходящиеся круги */}
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          component={m.div}
          // Начинаем с непрозрачного состояния в центре
          initial={{ scale: 0, opacity: 0.7 }}
          // Расширяемся и полностью исчезаем
          animate={{ scale: 4, opacity: 0 }}
          transition={{ ...rippleTransition, delay: i * 0.6 }} // Увеличим задержку между волнами для плавности
          sx={{
            position: 'absolute',
            width: 64,
            height: 64,
            borderRadius: '50%',
            // Убираем жесткую границу и добавляем мягкую тень для эффекта размытия
            boxShadow: `0 0 10px 4px ${alpha(theme.palette.primary.main, 0.5)}`,
          }}
        />
      ))}
    </Box>
  )
}

export default Loader
